import { BankTransactionType } from "Infrastructure/Api/Api";
import { useMarket } from "Market/Providers/CurrentMarketProvider";
import { useMemo } from "react";
import { useSearchParams } from "react-router";

/**
 * Available for inbound bank transactions
 */
export const usePaymentFilters = () => {
	const { market } = useMarket();
	const [query] = useSearchParams();

	return useMemo(
		() => ({
			marketId: query.get("marketId")
				? Number(query.get("marketId"))
				: (market?.id ?? undefined),
			query: query.get("query") ?? undefined,
			type: BankTransactionType.inbound,
			createdAtFrom: query.get("createdAtFrom") ?? undefined,
			createdAtTo: query.get("createdAtTo") ?? undefined,
			isRenovation: false,
		}),
		[query, market?.id],
	);
};
